import { FC, RefObject } from 'react';
import { useSearchStore } from '../../stores/search';

interface AlphabetDesktopProps {
  clickRefAlphabet: RefObject<any>;
  alphabetArr: string [];
}

export const AlphabetDesktop: FC<AlphabetDesktopProps> = (
  {
    clickRefAlphabet,
    alphabetArr,
  }) => {
  
  const setAlphabetSearchCharacter = useSearchStore((state) => state.setAlphabetSearchCharacter);
  const alphabetSearchCharacter = useSearchStore((state) => state.alphabetSearchCharacter);
  const isInputSearch = useSearchStore((state) => state.isInputSearch);
  
  return (
    <div ref={clickRefAlphabet} className="grid mb-8 lg:block hidden">
      <div className="w-full w-[1280px] m-auto h-auto z-40 flex justify-center">
        <ul
          
          className={`flex w-full lg:w-[55%] p-2 flex-wrap items-center gap-1 font-bold justify-center rounded-3xl bg-white bg-opacity-[14%] ${!isInputSearch ? 'opacity-100 pointer-events-auto' : 'pointer-events-none opacity-30'}`}>
          {alphabetArr.map((word) => (
            <li
              key={word}
              className={`p-2 hover:bg-white hover:text-black active:scale-75 active:bg-white scale-100 active:bg-opacity-70 bg-opacity-100 text-white text-center items-center flex justify-center cursor-pointer rounded-xl self-center w-10 h-10 transition-all duration-300 ${alphabetSearchCharacter === word ? 'bg-white text-gray-900' : ''}`}
              onClick={() => setAlphabetSearchCharacter(word)}>
              {word.toUpperCase()}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
